import { useEffect, useRef, useState } from "react";
import Arthurlytics from "./Arthurlytics";
import CJI2 from "./CJI2";
import NavigationPanel from "../Utils/NavigationPanel";
import styles from "./ProjectsLayout.module.css";
import Menace from "./Menace";
import AutomataTutor from "./AutomataTutor";
import Algorithms from "./Algorithms";
import FalloutHotels from "./FalloutHotels";
import ProjectCard from "../PageLayout/ProjectCard";
import JumpMusic from "../Utils/JumpMusic";
import { useMediaQuery } from "react-responsive";
import InfoPopup from "../Utils/InfoPopup";

export default function ProjectsLayout({active, sections}) {


    const projects = [ "Arthurlytics", "CJI2", "MENACE", "Automata Tutor", "Algorithms & Data Structures", "Fallout Hotels"];

    
    const isMobile = useMediaQuery({maxWidth: 599});



    return (
        <div id="Coding-Projects">
            <div className={styles.projectsHeader}>
                <h1 className={styles.title}>pROjEcTs</h1>
                <div className={styles.jumpButton}> 
                    <InfoPopup alighRight={true} info="Jump to music projects.">
                        <JumpMusic /> 
                    </InfoPopup>
                </div>
            </div>
            
            <ProjectCard>
                <p>Here are some of my personal coding projects which are presentable and complete enough to share. :)</p>
                <p>Some are university projects while others are hackathon entries. I’m also part of a little tech group called DJAZE (Dave, Jan, & Zaz), which is a friend group where we share ideas and build passion projects together.</p>        
            </ProjectCard>

            <br />

            <div className={styles.projectsContent}>

                { !isMobile && <div> <NavigationPanel active={active} projects={projects}/> </div> }
                
                <div className={styles.projects}>
                    <div ref={sections[0].ref} id="Arthurlytics">
                        <Arthurlytics />
                    </div>
                    <div ref={sections[1].ref} id="CJI2">
                        <CJI2 />
                    </div >
                    <div ref={sections[2].ref} id="MENACE">
                        <Menace />
                    </div>
                    <div ref={sections[3].ref} id="Automata Tutor">
                        <AutomataTutor />
                    </div>
                    <div ref={sections[4].ref} id="Algorithms & Data Structures">
                        <Algorithms />
                    </div>
                    <div ref={sections[5].ref} id="Fallout Hotels">
                        <FalloutHotels />
                    </div>
                </div>
            </div>
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />

        </div>
    );
}
